// GES-389 — pure DISPLAY helpers for the A-C.1 credit-limit lane. No money arithmetic: figures stay the exact text
// the API sends (GET /api/sales/credit-alerts); only the badge count, row status and threshold input are decided here.

// Badge / chip count = OVER customers only (near is shown in the table but never counted, D2).
export const overCount = (resp) => Number(resp && resp.rollup && resp.rollup.over_count) || 0;

// Snapshot health for the UI: 'unavailable' (no snapshot / request failed) | 'failed' (kept snapshot, last refresh
// errored or stale) | 'ok'. Never a silent zero.
export function laneHealth(resp) {
  if (!resp || !resp.rollup) return 'unavailable';
  return resp.job_status === 'error' || resp.stale ? 'failed' : 'ok';
}

// Row -> { status (i18n key under credit.alert.status), tone } from level + state.
export function rowModel(c) {
  if (c.level === 'near') return { status: 'near', tone: 'amber' };
  return { status: c.state === 'cash_only' ? 'overCash' : 'over', tone: 'red' };
}

// Same rule as the API: NN or NN.N text, 50.0 to 99.9.
export function validNearPct(text) {
  const s = String(text).trim();
  if (!/^\d{2}(\.\d)?$/.test(s)) return null;
  const n = Number(s);
  return n >= 50 && n <= 99.9 ? s : null;
}

// E5 (GES-440): `crossed_by` of an over row = the last override or limit change that put the customer over, or null. -> [i18n key under
// credit.alert.crossed.*, raw params] (the card formats date / money); null when the API sends none (older server: nothing shown).
export function crossedByOf(c) {
  const x = c && c.crossed_by;
  if (!x || (x.kind !== 'override' && x.kind !== 'limit_change')) return null;
  return x.kind === 'override'
    ? ['override', { at: x.at, who: x.by || '', reason: x.reason || '' }]
    : ['limit_change', { at: x.at, who: x.by || '', from: x.from, to: x.to }];
}
